import React from "react";

export const PlusIcon = ({className}: any) => (
    <i className={`glyphicon glyphicon-plus ${className}`} />
);
